class SubscriptionFlow extends HTMLElement {
  #state = {
    limit: null,
    selected_products: [],
  };

  constructor() {
    super();
    this.redirect = false; // change it to true if want to redirect to checkout
    this.tabItemHeads = Array.from(this.querySelectorAll(".timelinetab-item"));
    this.limitersRawData = JSON.parse(
      this.querySelector("#flow_sub_header").innerText
    );
    const { limits } = this.limitersRawData;
    this.limitersData = limits;
    this.#state.limit = limits[0].value;
    this.#state.currentTab = 1;
    this.limitSelectors = Array.from(this.querySelectorAll(".limit-option"));
    this.miniCart = this.querySelector(".flow-mini__cart");
    this.currentCount = this.querySelector("#current_count");
    this.totalCount = this.querySelector("#total_count");
    this.subscriptionPrice = this.querySelector("#subscription_price");
    this.totalPrice = this.querySelector(".flow-total_price");
    this.totalSavingsPrice = this.querySelector(".flow-total_savings");

    this.prevButton = this.querySelector(".backward-button");
    this.nextButton = this.querySelector(".forward-button");
    this.finishButton = this.querySelector(".finish-button");
    this.addToMiniCartBtns = Array.from(
      this.querySelectorAll(".subscription__btn-add")
    );
    this.quantityBtns = Array.from(this.querySelectorAll(".quantity__button"));
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
  }

  connectedCallback() {
    this.tabItemHeads.forEach((tabItem) =>
      tabItem.addEventListener("click", this.tabClickHandler.bind(this), true)
    );

    this.limitSelectors.forEach((limitSelector) =>
      limitSelector.addEventListener(
        "click",
        this.limitClickHandler.bind(this),
        true
      )
    );

    this.addToMiniCartBtns.forEach((addToMiniCartBtn) =>
      addToMiniCartBtn.addEventListener(
        "click",
        this.addToMiniCartHandler.bind(this),
        true
      )
    );

    this.quantityBtns.forEach((quantityBtn) =>
      quantityBtn.addEventListener(
        "click",
        this.handleOperationClick.bind(this),
        true
      )
    );

    this.prevButton.addEventListener(
      "click",
      this.handleDirection.bind(this),
      true
    );
    this.nextButton.addEventListener(
      "click",
      this.handleDirection.bind(this),
      true
    );

    this.finishButton.addEventListener(
      "click",
      this.handleFinish.bind(this),
      true
    );
  }

  addToMiniCartHandler(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const variantId = +target.getAttribute("data-id");
    const productForm = target.closest("product-form");
    const productScript = productForm.querySelector(
      "script[type='application/json']"
    );
    if (productScript) {
      const productData = JSON.parse(productScript.innerHTML);
      if (!productData) {
        throw "Issue in parsing, please check if the content of script tag";
      }
      const inputQuantity = productForm.querySelector(".quantity__input");
      inputQuantity.value = 1;
      this.addItemToMiniCart(variantId, productData);
    }

    productForm.classList.add("selected");
    this.renderMiniCart();
  }

  addItemToMiniCart(variantId, productData) {
    const { title, variants } = productData;
    const variant = variants.find((variant) => variant.id === variantId);
    const ItemTitle = title + " " + variant.title;
    const ItemImage = variant.featured_image
      ? variant.featured_image.src
      : productData?.featured_image;
    const ItemImageAlt = variant.featured_image
      ? variant.featured_image.alt
      : productData?.title;
    const ItemIndex = this.uniqueId;
    const ItemPrice = variant.price;
    console.log("variant", variant);
    const ItemSellingPlan =
      variant?.selling_plan_allocations[
        variant.selling_plan_allocations.length - 1
      ] || "";
    const ItemComparePrice = variant.compare_at_price || 0;
    const ItemId = variant.id;
    const Item = {
      ItemId,
      ItemTitle,
      ItemImage,
      ItemImageAlt,
      ItemIndex,
      ItemPrice,
      ItemComparePrice,
      ItemSellingPlan: ItemSellingPlan?.selling_plan?.id || "",
    };
    this.#state.selected_products.push(Item);
  }

  handleDirection(event) {
    const { limit, selected_products } = this.#state;
    const direction = event.currentTarget.getAttribute("name");
    const currentTab = this.querySelector(".timelinetab-item.active");
    const currentTabIndex = +currentTab.dataset.tabIndex;

    if (currentTabIndex === 1) {
      this.prevButton.style.display = "none";
      this.nextButton.style.display = "block";
      this.finishButton.style.display = "none";
    }

    if (currentTabIndex === 5) {
      this.prevButton.style.display = "block";
      this.nextButton.style.display = "none";
      this.finishButton.style.display = "block";
    }

    if (currentTabIndex > 1 && currentTabIndex < 5) {
      this.prevButton.style.display = "block";
      this.nextButton.style.display = "block";
      this.finishButton.style.display = "none";
    }

    if (direction) {
      if (direction === "next") {
        const newTabIndex = currentTabIndex + 1;
        if (newTabIndex <= 5) {
          this.querySelector(
            `.timelinetab-item[data-tab-index='${newTabIndex}']`
          ).click();
        }
      }

      if (direction === "prev") {
        const newTabIndex = currentTabIndex - 1;
        if (newTabIndex >= 1) {
          this.querySelector(
            `.timelinetab-item[data-tab-index='${newTabIndex}']`
          ).click();
        }
      }
      if (currentTabIndex > 1 && currentTabIndex < 5) {
        this.prevButton.style.display = "none";
        this.nextButton.style.display = "block";
        this.finishButton.style.display = "none";
      }

      if (currentTabIndex === 5) {
        this.prevButton.style.display = "block";
        this.nextButton.style.display = "none";
        this.finishButton.style.display = "block";
      }
    }

    if (direction === "prev") {
      if (currentTabIndex === 1) {
        this.prevButton.style.display = "none";
        this.nextButton.style.display = "block";
        this.finishButton.style.display = "none";
        return;
      }

      if (currentTabIndex > 1 && currentTabIndex < 5) {
        this.prevButton.style.display = "block";
        this.nextButton.style.display = "block";
        this.finishButton.style.display = "none";
      }
      currentTab.previousElementSibling?.click();
      return;
    }

    if (direction === "next") {
      if (currentTabIndex === 5) {
        this.prevButton.style.display = "block";
        this.nextButton.style.display = "none";
        this.finishButton.style.display = "block";
        return;
      }
      if (currentTabIndex > 1 && currentTabIndex < 5) {
        this.prevButton.style.display = "block";
        this.nextButton.style.display = "block";
        this.finishButton.style.display = "none";
      }
      currentTab.nextElementSibling?.click();
      return;
    }

    if (limit === selected_products.length) {
      this.finishButton.removeAttribute("disabled");
    } else {
      this.finishButton.setAttribute("disabled", true);
    }
  }

  handleOperationClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const productForm = target.closest("product-form");
    const inputQuantity = target
      .closest("quantity-input")
      .querySelector(".quantity__input");
    let currentInputValue = +inputQuantity.value;
    const variantId = +productForm
      .querySelector(".subscription__btn-add")
      .getAttribute("data-id");
    const operation = target.getAttribute("name");
    let inputValue = currentInputValue;
    if (operation === "plus") {
      inputValue = currentInputValue + 1;
      const productScript = productForm.querySelector(
        "script[type='application/json']"
      );
      if (productScript) {
        const productData = JSON.parse(productScript.innerHTML);
        if (!productData) {
          throw "Issue in parsing, please check if the content of script tag";
        }
        const { title, variants } = productData;
        const variant = variants.find((variant) => variant.id === variantId);
        const ItemTitle = title + " " + variant.title;
        const ItemImage = variant.featured_image
          ? variant.featured_image.src
          : productData?.featured_image;
        const ItemImageAlt = variant.featured_image
          ? variant.featured_image.alt
          : productData?.title;
        const ItemIndex = this.uniqueId;
        const ItemPrice = variant.price;
        const ItemComparePrice = variant.compare_at_price || 0;
        const ItemId = variant.id;
        const Item = {
          ItemId,
          ItemTitle,
          ItemImage,
          ItemImageAlt,
          ItemIndex,
          ItemPrice,
          ItemComparePrice,
        };
        this.#state.selected_products.push(Item);
      }
      productForm.classList.add("selected");
    } else if (operation === "minus") {
      inputValue = currentInputValue - 1;
      const variant = this.#state.selected_products.find(
        (item) => item.ItemId === variantId
      );
      this.#state.selected_products = this.#state.selected_products.filter(
        (item) => item.ItemIndex !== variant.ItemIndex
      );
    }

    if (inputValue <= 0) {
      inputQuantity.value = 0;
      productForm.classList.remove("selected");
    }

    this.renderMiniCart();
  }

  handleItemActionClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const ItemIndex = target.getAttribute("data-index");
    const variant = this.#state.selected_products.find(
      (item) => item.ItemIndex == ItemIndex
    );
    this.#state.selected_products = this.#state.selected_products.filter(
      (item) => item.ItemIndex != ItemIndex
    );
    const productForm = this.querySelector(
      `.subscription__btn-add[data-id='${variant.ItemId}']`
    ).closest("product-form");
    productForm.querySelector(".quantity__input").value =
      +productForm.querySelector(".quantity__input").value - 1;
    const currentValue = +productForm.querySelector(".quantity__input").value;
    productForm.classList.toggle("selected", currentValue !== 0);
    this.renderMiniCart();
  }

  handleFinish() {
    console.log("Finish.....");
    const items = this.getMergedProducts(this.#state.selected_products).map(
      (item) => {
        return {
          id: item.id,
          quantity: item.quantity,
          selling_plan: item.selling_plan,
        };
      }
    );

    console.log(items);

    let formData = { items };

    const cart_add_url = `${
      window.Shopify.routes.root
    }cart/add.js?sections=${this.cart
      .getSectionsToRender()
      .map((section) => section.id)
      .join(",")}`;
    const config = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    };
    fetch(cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        const lastItem = items[items.length - 1];
        // If redirect to checkout
        if (this.redirect) {
          window.location.href = window.Shopify.routes.root + "checkout";
        } else {
          this.cart.renderContents({ ...response, items: [lastItem] });
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
      });
  }

  tabClickHandler(e) {
    this.querySelectorAll(".tab-data").forEach((tabData) =>
      tabData.classList.remove("tabsdata-show")
    );

    this.tabItemHeads.forEach((tabItemHead) =>
      tabItemHead.classList.remove("active")
    );

    const tabHead = e.currentTarget;
    const tabDetail = document.getElementById(tabHead.getAttribute("data-tab"));
    if (tabHead && tabDetail) {
      this.#state.currentTab = tabHead.dataset.tabIndex;
      tabHead.classList.add("active");
      tabDetail.classList.add("tabsdata-show");
    }
    console.log(this.#state);
    this.handleDirection(e);
  }

  limitClickHandler(event) {
    this.limitSelectors.forEach((limitSelector) =>
      limitSelector.classList.remove("selected")
    );
    event.currentTarget.classList.add("selected");
    const newLimit = Number(event.currentTarget.dataset.optionValue);
    this.#state.limit = newLimit;
    this.reset();
  }

  renderPlaceholders() {
    const { limit, selected_products } = this.#state;
    const placeholderCount = limit - selected_products.length;
    this.miniCart
      .querySelectorAll(".selected-option-placeholder")
      .forEach((placeholder) => placeholder.remove());
    for (let i = 0; i < placeholderCount; i++) {
      this.miniCart.insertAdjacentHTML("beforeend", this.placeholderItem);
    }
  }

  renderMiniCart() {
    const { limit, selected_products } = this.#state;
    const items = this.#state.selected_products;
    this.miniCart.innerHTML = "";

    for (let item of items) {
      let itemDeskHtml = this.selectedItem;
      let stringsToReplaceWith = { ...item };
      itemDeskHtml = itemDeskHtml.replace(
        /\b(?:ItemImage|ItemImageAlt|ItemIndex|ItemTitle)\b/gi,
        (matched) => stringsToReplaceWith[matched]
      );
      this.miniCart.insertAdjacentHTML("beforeend", itemDeskHtml);
    }

    if (items.length < this.#state.limit) {
      const placeholderItems = this.#state.limit - items.length;
      for (let i = 0; i < placeholderItems; i++) {
        let itemDeskHtml = this.placeholderItem;
        let stringsToReplaceWith = { ItemIndex: i };
        itemDeskHtml = itemDeskHtml.replace(
          /\b(?:ItemIndex)\b/gi,
          (matched) => stringsToReplaceWith[matched]
        );
        this.miniCart.insertAdjacentHTML("beforeend", itemDeskHtml);
      }
    }

    if (limit === selected_products.length) {
      this.addToMiniCartBtns.forEach((addToMiniCartBtn) => {
        addToMiniCartBtn.setAttribute("disabled", true);
        addToMiniCartBtn.classList.add("disabled");
      });
      this.quantityBtns.forEach((quantityBtn) => {
        if (quantityBtn.getAttribute("name") === "plus") {
          quantityBtn.setAttribute("disabled", true);
          quantityBtn.classList.add("disabled");
        }
      });
      this.finishButton.removeAttribute("disabled");
    } else {
      this.quantityBtns.forEach((quantityBtn) => {
        if (quantityBtn.getAttribute("name") === "plus") {
          quantityBtn.removeAttribute("disabled", true);
          quantityBtn.classList.remove("disabled");
        }
      });
      this.addToMiniCartBtns.forEach((addToMiniCartBtn) => {
        addToMiniCartBtn.removeAttribute("disabled", true);
        addToMiniCartBtn.classList.remove("disabled");
      });
      this.finishButton.setAttribute("disabled", true);
    }

    this.itemActionBtns = Array.from(
      this.querySelectorAll(".selected-item-remove")
    );

    if (this.itemActionBtns.length) {
      this.itemActionBtns.forEach((itemActionBtn) =>
        itemActionBtn.addEventListener(
          "click",
          this.handleItemActionClick.bind(this),
          true
        )
      );
    }

    this.currentCount.innerText = this.#state.selected_products.length;
    console.log("Current state", this.#state);
  }
  reset() {
    const { limit } = this.#state;
    this.#state.selected_products = [];
    this.miniCart.innerHTML = "";
    this.currentCount.innerText = 0;
    this.totalCount.innerText = limit;
    this.subscriptionPrice.innerText = this.limitersData.find(
      (limitData) => limitData.value === limit
    ).price;
    this.totalPrice.textContent = this.limitersData.find(
      (limitData) => limitData.value === limit
    ).price;
    this.totalSavingsPrice.textContent = "$0";
    this.renderPlaceholders();
    this.quantityBtns.forEach((quantityBtn) => {
      quantityBtn
        .closest("quantity-input")
        .querySelector(".quantity__input").value = 0;
      if (quantityBtn.getAttribute("name") === "plus") {
        quantityBtn.removeAttribute("disabled", true);
        quantityBtn.classList.remove("disabled");
      }
    });
    this.addToMiniCartBtns.forEach((addToMiniCartBtn) => {
      addToMiniCartBtn.closest("product-form").classList.remove("selected");
      addToMiniCartBtn.removeAttribute("disabled", true);
      addToMiniCartBtn.classList.remove("disabled");
    });
  }
  getMergedProducts(items) {
    const itemMap = {};
    const bundleId = new Date().getTime();
    items.forEach((item) => {
      if (itemMap[item.ItemId]) {
        itemMap[item.ItemId].quantity += 1;
      } else {
        itemMap[item.ItemId] = {
          ...item,
          id: item.ItemId,
          quantity: 1,
          selling_plan: item.ItemSellingPlan,
          properties: { _bundle_id: bundleId },
        };
      }
    });

    return Object.values(itemMap);
  }

  get placeholderItem() {
    return `<div class="selected-option-placeholder"> <div class="icon-wrapper"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 32" class="squatch-icon icon-BarSoap type-icon" style="--size: 35px;" > <path d="m27.969 14.97.386-.476.573-.708.444-.554V8.216h-14.41a4.5 4.5 0 0 0-.585-1.883l.012.022h.077a3.078 3.078 0 1 0-3.078-3.078v.007q.01.5.161.95l-.006-.022a4.462 4.462 0 0 0-4.11 7.576l.002.002-2.208 2.749c-.135 0-.264-.052-.399-.058a4.6 4.6 0 0 0-3.509 1.352c-.835.819-1.353 1.959-1.353 3.219s.518 2.401 1.352 3.219l.001.001v1.616c0 .288.234.522.522.522h3.026l.002.026-.003.027v-.001a3.08 3.08 0 0 0 2.643 2.76l.016.002h.405c.835 0 1.593-.334 2.145-.876h-.001c.508-.497.842-1.17.901-1.921l.001-.01h8.621c.424-.01.806-.183 1.088-.457a.22.22 0 0 0 .135-.083v-.001l1.558-1.932a4.38 4.38 0 0 0 2.832 1.043h.009a4.462 4.462 0 0 0 2.757-7.97l-.01-.007zM14.461 1.288a2.002 2.002 0 1 1-2.002 2.002c0-1.106.896-2.002 2.002-2.002m-7.34 7.275a3.394 3.394 0 0 1 6.766-.363l.001.015h-3.316a.5.5 0 0 0-.398.192l-.001.001-2.06 2.575a3.37 3.37 0 0 1-.992-2.392v-.004zm2.794 15.814a2.06 2.06 0 0 1-.586 1.198 2.003 2.003 0 0 1-3.379-1.188l-.001-.01v-.045a2 2 0 0 1 .054-.657L6 23.689a.93.93 0 0 0-.206-.87l.001.001a.94.94 0 0 0-.673-.284l-.037.001h.002-.109a3.8 3.8 0 0 1-1.005-.002l.02.002a3.495 3.495 0 0 1-2.944-3.447c0-.959.387-1.827 1.012-2.458a3.46 3.46 0 0 1 2.297-1.017h.388c.129 0 .193.032.29.045.221.029.419.074.61.135l-.024-.007a3.6 3.6 0 0 1 1.719 1.221l.006.009c.277.375.484.82.588 1.304l.004.023c.038.128.068.279.083.434l.001.01q.003.021.002.045c-.001.024-.001.032-.003.047v-.002.048q0 .261-.035.512l.002-.019a3.45 3.45 0 0 1-.421 1.441l.009-.018a.91.91 0 0 0-.036.862l-.002-.005a.96.96 0 0 0 .637.52l.007.001h.103a2 2 0 0 1 1.583 1.736l.001.009a2 2 0 0 1-.001.46l.001-.009zm11.159-7.579-1.114 1.346a.37.37 0 0 1-.293.142H9.052a4.3 4.3 0 0 0-.654-1.742l.01.017a4.6 4.6 0 0 0-1.993-1.701l-.029-.011 1.932-2.421.341-.418.354-.418L10.867 9.3h16.258l-4.41 5.466zm4.14 5.093a3.37 3.37 0 0 1-2.168-.802l.005.004 4.25-5.273a3.392 3.392 0 0 1-2.083 6.071h-.003zm.392-18.408h1.075v1.371h-1.075zm0-2.749h1.075v1.378h-1.075zM24.087 2.26h1.378v1.075h-1.378zm2.749 0h1.371v1.075h-1.371zM15.582 29.547h1.075v1.371h-1.075zm0-2.743h1.075v1.378h-1.075zm-1.52 1.52h1.371v1.075h-1.371zm2.749 0h1.371v1.075h-1.371zM1.552 11.499h1.075v1.378H1.552zm0-2.742h1.075v1.371H1.552zM.026 10.276h1.378v1.075H.026zm2.749 0h1.371v1.075H2.775z"> </path> </svg> </div> </div>`;
  }

  get selectedItem() {
    return `
      <div class="selected-option">
          <button type="button" class="subscription-remove selected-item-remove" data-index="ItemIndex">
              <svg class="b-icon bi bi-x remove-icon" viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="x" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                  <g>
                      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z">
                      </path>
                  </g>
              </svg>
              <span class="visually-hidden">Remove Item - ItemTitle</span>
          </button>
          <div class="image-wrapper loading">
              <img loading="lazy" width="auto" height="auto" src="ItemImage" alt="ItemTitle">
          </div>
          <span>ItemTitle</span>
      </div>
      `;
  }

  get uniqueId() {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < 4) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }
}

if (!customElements.get("subscription-flow")) {
  customElements.define("subscription-flow", SubscriptionFlow);
}
